module.exports = __webpack_public_path__ + "img/zdjsxm-bg.1ae84ce1.png";